import { ValidatorFn, Validators } from '@angular/forms';

export const leastOneDigit: ValidatorFn = (control) => (!/\d/.test(control.value) ? { missedDigit: true } : null);
export const leastOneSpecial: ValidatorFn = (control) =>
  !/[@$!%*#?&_.-]/.test(control.value) ? { missedSpecial: true } : null;
export const leastOneUppercase: ValidatorFn = (control) =>
  !/[A-Z]/.test(control.value) ? { missedUpper: true } : null;

export const passwordValidator: ValidatorFn = (control) =>
  leastOneDigit(control) || leastOneUppercase(control) || leastOneSpecial(control) || Validators.minLength(8)(control);
